import React from 'react';
import HomeEcosystemMindMap from './HomeEcosystemMindMap';

const HomeEcosystemHero = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden bg-white">
        <HomeEcosystemMindMap />
    </section>
  );
};

export default HomeEcosystemHero;